import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * dummy class for legacy widget.
 */
const LegacyWidgetContainer = (props) => {
    useEffect(() => {
        const { onWidgetInit, wrapperElement } = props;

        if (onWidgetInit) {
            onWidgetInit({
                widgetContainer: wrapperElement.current,
                props,
            });
        }
    }, []);

    return <React.Fragment />;
};

LegacyWidgetContainer.propTypes = {
    wrapperElement: PropTypes.object,
    onWidgetInit: PropTypes.func,
};

export default LegacyWidgetContainer;
